import { render, staticRenderFns } from "./LogisticsWeightTable.vue?vue&type=template&id=17d1127e&scoped=true"
import script from "./LogisticsWeightTable.vue?vue&type=script&lang=js"
export * from "./LogisticsWeightTable.vue?vue&type=script&lang=js"
import style0 from "./LogisticsWeightTable.vue?vue&type=style&index=0&id=17d1127e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d1127e",
  null
  
)

export default component.exports